import {
  AcceptChallengeResult,
  ChallengeDetails,
  ChallengeList,
  SponsoredChallengesList,
  SponsoredCampaignStatistics,
  SubmitChallengeResult,
  SolvedChallengesResult,
  TaskList,
  AcceptedChallengeDetails, DownloadChallengeSolutionZipResult,
} from "./TaskManagementServiceResponses";
import { SolvedChallengesResultDict } from "@/services/task-management/TaskManagementServiceResponses";

export class TaskManagementServiceStub {
  constructor(auth) {
    this.authService = auth;
  }

  accceptChallenge(rewardOption, userUuid) {
    let result = new AcceptChallengeResult();
    setTimeout(function() {
      result.apiData = {};
      result.loaded = true;
    }, Math.random() * 1500);
    return result;
  }

  submitChallenge() {
    let result = new SubmitChallengeResult();
    setTimeout(function() {
      result.apiData = {};
      result.loaded = true;
    }, Math.random() * 1500);
    return result;
  }

  getChallengeList(accepted, region) {
    let result = new ChallengeList();
    setTimeout(function() {
      result.apiData = [
        {
          id: "9c778212-5cf0-4b5d-b2b5-49bea7eb1d53",
          title: "FizzBuzz JavaScript",
          slug: "fizzbuzz-javascript",
          complexity: 1,
          description: "FizzBuzz in JavaScript. Let's go!",
          tasks: 1,
          image: "https://production-task-management-media-storage.s3.amazonaws.com/tc_icon.png",
          solved: false,
          company: "",
          rewardDefault: 10,
          rewardSponsored: 1000,
          type: "CHALLENGE",
          sponsored: true,
          technology: {
            name: "",
            language: "JavaScript",
            icon: "https://production-task-management-media-storage.s3.amazonaws.com/js-logo.png",
          },
        },
        {
          id: "9c778212-5cf0-4b5d-b2b5-49bea7eb1d53",
          title: "FizzBuzz PHP",
          slug: "fizzbuzz-php",
          complexity: 1,
          description: "FizzBuzz in JavaScript. Let's go!",
          tasks: 1,
          image: "https://production-task-management-media-storage.s3.amazonaws.com/tc_icon.png",
          solved: false,
          company: "c770f424-6199-416c-bb45-d7f6c1aa8c9e",
          rewardDefault: 10,
          rewardSponsored: 1000,
          type: "CHALLENGE",
          sponsored: true,
          technology: {
            name: "",
            language: "JavaScript",
            icon: "https://production-task-management-media-storage.s3.amazonaws.com/js-logo.png",
          },
        },
        {
          id: "e918f361-abe7-4187-a89a-8be94bd4f64b",
          title: "The mighty oracle for 'CannotDoMuch#' programs",
          slug: "the-mighty-oracle-for-cannotdomuch-programs",
          complexity: 4,
          description:
            "Imagine you are working for a very wicked software company. Everyone in this company writes software using a language called CannotDoMuch#. The language is very limited, but it is sufficient to write programs for the company's clients, because they are also very wicked. They do not care about the actual behavior of the software - the only thing they care about is that you can - for any given number - precisely say whether your program can produce this number as output (or not).",
          tasks: 3,
          image: "https://production-task-management-media-storage.s3.amazonaws.com/Spaceship-Yellow.png",
          solved: false,
          company: "c25bfe23-e621-465e-911c-0c6c81e2496c",
          rewardDefault: 10,
          rewardSponsored: 1000,
          type: "CHALLENGE",
          sponsored: true,
          technology: {
            name: "Spring Boot",
            language: "Java",
            icon:
              "https://production-task-management-media-storage.s3.amazonaws.com/spring-by-pivotal-9066b55828deb3c10e27e609af322c40.png",
          },
        },
        {
          id: "5fb64776-ec46-48ae-ae04-b9c77949eb80",
          title: "Number of Islands",
          slug: "number-of-island",
          company: "c25bfe23-e621-465e-911c-0c6c81e2496c",
          complexity: 2,
          description:
            "You have a 2D map with water (marked by 0) and land (marked by 1). Connected parts of land are forming an island. Your algorithm should take such a map and return the number of islands. Many companies like Microsoft, Amazon or Visa ask this in an interview.",
          image: "https://production-task-management-media-storage.s3.amazonaws.com/028__Desert_Island-Yellow.png",
          rewardDefault: 100,
          rewardSponsored: 1000,
          solved: true,
          sponsored: true,
          tasks: 3,
          type: "INTERVIEW_TEST",
          technology: {
            icon:
              "https://production-task-management-media-storage.s3.amazonaws.com/300px-Java_programming_language_logo.svg.png",
            language: "Java",
            name: "",
            title2: "Number of islands",
          },
          statistics: {
            acceptancesCount: 1,
            solutionsCount: 1,
            publicUserIdOfFirstSolution: "1",
          },
        },
      ];
      result.loaded = true;
    }, Math.random() * 1500);
    return result;
  }

  getChallengeDetails(challengeIdOrSlug, region) {
    let result = new ChallengeDetails();
    setTimeout(() => {
      result.loaded = true;
      result.apiData = {
        id: "54796871-1190-499d-8ec6-006ab5c2eb64",
        title: "The mighty oracle for 'CannotDoMuch#' programs",
        slug: "the-mighty-oracle-for-cannotdomuch-programs",
        complexity: 4,
        description:
          "Imagine you are working for a very wicked software company. Everyone in this company writes software using a language called CannotDoMuch#. The language is very limited, but it is sufficient to write programs for the company's clients, because they are also very wicked. They do not care about the actual behavior of the software - the only thing they care about is that you can - for any given number - precisely say whether your program can produce this number as output (or not).",
        description_detail:
          'Imagine you are working for a very <strong>wicked</strong> software company. Everyone in this company writes software using a language called <parameter>CannotDoMuch<strong style="font-size:1.5rem;">#</strong></parameter>. The language is very limited, but it is sufficient to write programs for the company\'s clients, because they are also very <strong>wicked</strong>. They do not care about the actual behavior of the software - the only thing they care about is that you can - for any given number - precisely say whether your program can produce this number as output (or not).\r\n<p>What? Too wicked? Let\'s look at an example. Here is a sample <parameter>CannotDoMuch<strong style="font-size:1.5rem;">#</strong></parameter> program:</p>\r\n<pre>INPUT x\r\nIF x < 0 THEN\r\n    x = 42\r\nELSE\r\n    x = 23\r\nEND\r\n</pre>\r\n<p>In the first line, the program will ask the user to input an integer number. Then, depending on the entered number, the program will either assign <parameter>42</parameter> or <parameter>23</parameter> to the variable <parameter>x</parameter>. It is easy to see that once the program is done, <parameter>x</parameter> will be either <parameter>42</parameter> or <parameter>23</parameter>. There is no way that <parameter>x</parameter> can have any other value. And this is exactly what the clients want to know.\r\n</p>\r\n<p>\r\nObviously, your co-workers write tens of thousands of such programs every day, because the clients have a high demand for this kind of software. Also, since <parameter>CannotDoMuch<strong style="font-size:1.5rem;">#</strong></parameter> is so limited in its functionality, the only way to keep up with the clients\' requirements is to write more code.\r\n</p>\r\n<p>\r\nYour boss is a smart guy (after all, he invented <parameter>CannotDoMuch<strong style="font-size:1.5rem;">#</strong></parameter>) and therefore asks you to automate this task of checking whether a <parameter>CannotDoMuch<strong style="font-size:1.5rem;">#</strong></parameter> program can produce a certain output or not. He has already done most of the heavy-lifting and has defined an interface which you need to implement called:\r\n</p>\r\n<p>\r\n<parameter>CannotDoMuchProgramAnalyzer</parameter>\r\n</p>\r\n<p>\r\nHe asks you to implement this interface such that he can pass in a <parameter>CannotDoMuch<strong style="font-size:1.5rem;">#</strong></parameter> program, the name of a variable and a concrete value (e.g., <parameter>42</parameter>). Your implementation then just needs to return <parameter>true</parameter> if the variable can have this value when the program execution is done, or <parameter>false</parameter> if the variable cannot have this value.\r\n</p>\r\nHe quickly explains that the <parameter>CannotDoMuch<strong style="font-size:1.5rem;">#</strong></parameter> programs are passed to your analyzer as object tree where each object in the tree represents a piece of code. So there is an <parameter>IntegerInput</parameter> class to represent <parameter>INPUT</parameter> statements, an <parameter>IfStatement</parameter> class to represent <parameter>IF/THEN/ELSE</parameter> statements, an <parameter>Assignment</parameter> class to assign expressions to variables, and some more classes which (he is sure of) you\'ll figure out by yourself. Then, he drives off with his Ferrari into the sunset right after reminding you that this needs to be done by tomorrow morning.</p>',
        solved: true,
        surveyUrl: "",
        actions: { submit: {} },
        nextTaskId: "f0402749-0cee-45ae-9c90-7a6a0360d0f6",
        company: "c770f424-6199-416c-bb45-d7f6c1aa8c9e",
        rewardDefault: 100,
        selectedReward: "WITH_SPONSORING",
        type: "CHALLENGE",
        regions: ["Sachsen", "Sachsen-Anhalt", "Brandenburg", "Berlin", "Bremen", "Bayern", "Schweiz", "Thüringen"],
        regionsNotAvailable: [
          "Östereich",
          "Baden-Württemberg",
          "Niedersachsen",
          "Rheinland-Pfalz",
          "Schleswig-Holstein",
        ],
        inUsersRegionAvailable: true,
        technology: {
          name: "Spring Boot",
          language: "Java",
          icon:
            "https://production-task-management-media-storage.s3.amazonaws.com/300px-Java_programming_language_logo.svg.png",
        },
        tasks: [
          {
            task_id: "f0402749-0cee-45ae-9c90-7a6a0360d0f6",
            index: 0,
            title: "X is Y is Z",
            description:
              'Since you have no clue how to analyze CannotDoMuch# programs, you check out some of your co-workers\' code and pick a program that looks simple.\r\n\r\nAs additional help you have found the following <a href="https://s3.eu-central-1.amazonaws.com/task-static-files/devboost-challenge/devboostentwicklerheldchallenge.png" class="open-in-editor"  target="blank";>Class Diagram</a>.',
            solved: true,
          },
          {
            task_id: "0b465303-ae29-44fc-9d17-e61732585a01",
            index: 1,
            title: "Thirteen is not less than zero",
            description:
              'Now that you\'re familiar with the variables and assignments in CannotDoMuch# programs, you check out some more code of your co-workers.\r\n\r\nSince you have no clue how to analyze CannotDoMuch# programs, you check out some of your co-workers\' code and pick a program that looks simple.\r\n\r\nAs additional help you have found the following <a href="https://s3.eu-central-1.amazonaws.com/task-static-files/devboost-challenge/devboostentwicklerheldchallenge.png" class="open-in-editor"  target="blank";>Class Diagram</a>.',
            solved: true,
          },
          {
            task_id: "1b20123e-0d49-4ea4-a213-59e869675172",
            index: 2,
            title: "Users that enter numbers are the worst",
            description:
              'So, you\'ve handled variables, assignments and <code>IF/ELSE</code> statements. However, there is also the <code>INPUT</code> statement which prompts users to enter an integer number in a <code>CannotDoMuch# </code> program. So it is not much of a surprise that you find code that uses the <code>INPUT</code> statement.\r\n\r\nSince you have no clue how to analyze CannotDoMuch# programs, you check out some of your co-workers\' code and pick a program that looks simple.\r\n\r\nAs additional help you have found the following <a href="https://s3.eu-central-1.amazonaws.com/task-static-files/devboost-challenge/devboostentwicklerheldchallenge.png" class="open-in-editor"  target="blank";>Class Diagram</a>.',
            solved: true,
          },
        ],
        files: {
          "f0402749-0cee-45ae-9c90-7a6a0360d0f6": [
            "src/main/java/de/devboost/entwicklerheldchallenge/CannotDoMuchProgramAnalyzer.java",
          ],
          "1b20123e-0d49-4ea4-a213-59e869675172": [
            "src/main/java/de/devboost/entwicklerheldchallenge/CannotDoMuchProgramAnalyzer.java",
          ],
          "0b465303-ae29-44fc-9d17-e61732585a01": [
            "src/main/java/de/devboost/entwicklerheldchallenge/CannotDoMuchProgramAnalyzer.java",
          ],
        },
        statistics: {
          acceptancesCount: 2,
          solutionsCount: 2,
          publicUserIdOfFirstSolution: "6296f40d95c3fdeb12216d525f44f36d",
        },
      };
      if (!this.authService.isAuthenticated()) {
        delete result.challenge_data.statistics.publicUserIdOfFirstSolution;
      }
    }, Math.random() * 1500);

    return result;
  }

  getSponsoredCampaignsList() {
    let result = new SponsoredChallengesList();
    setTimeout(function() {
      result.apiData = [
        {
          campaign_id: "5fb64776-ec46-48ae-ae04-b9c77949eb80",
          title: "Number of islands",
          acceptances: 352,
          submissions: 77,
        },
        {
          campaign_id: "f2e99daa-133a-4b9a-b1d8-bb6cdc587b8b",
          title: "New Spaceship validation when entering the motherships",
          acceptances: 157,
          submissions: 41,
        },
        {
          campaign_id: "54796871-1190-499d-8ec6-006ab5c2eb64",
          title: "The mighty oracle for 'CannotDoMuch#' programs",
          acceptances: 115,
          submissions: 30,
        },
        {
          campaign_id: "0d515182-8379-439b-8e14-18e53f9a57cd",
          title: "Find the Words",
          acceptances: 143,
          submissions: 31,
        },
      ];
      result.loaded = true;
    }, Math.random() * 1500);
    return result;
  }

  getSponsoredCampaignStatistics(campaignId) {
    let result = new SponsoredCampaignStatistics();
    setTimeout(function() {
      let accepted_sum = 0;
      let solved_sum = 0;
      let labelStrings = [];
      let solved_statistics = [];
      let acceptance_statistics = [];
      let maxData = 12;
      let minValue = Math.round(Math.random() * 50);
      let maxValue = Math.round(Math.random() * 140) + 10;
      for (let i = 0; i < maxData; i++) {
        let text = `${i+1}`;
        labelStrings.push(text);
        let value = Math.round(Math.random() * maxValue) + minValue;
        solved_statistics.push(value);
        solved_sum += value;
        value += Math.round(Math.random() * maxValue) + minValue;
        acceptance_statistics.push(value);
        accepted_sum += value;
      }
      result.apiData = {
        "solved_result": {
          labels: labelStrings,
          data: solved_statistics,
        },
        "acceptance_result": {
          labels: labelStrings,
          data: acceptance_statistics,
        },
        "overall_accepted": accepted_sum,
        "overall_solved": solved_sum,
      };
      result.loaded = true;
    }, Math.random() * 1500);
    return result;
  }

  getDataOfMultipleChallenges() {
    let result = new ChallengeList();
    setTimeout(function() {
      result.apiData = [
        {
          id: "e918f361-abe7-4187-a89a-8be94bd4f64b",
          title: "The mighty oracle for 'CannotDoMuch#' programs",
          slug: "the-mighty-oracle-for-cannotdomuch-programs",
          icon: "https://production-task-management-media-storage.s3.amazonaws.com/tc_icon.png",
          technology: {
            id: 1,
            name: "Spring Boot",
            language: "Java",
          },
        },
        {
          id: "e6458744-d7bf-4fa1-8689-ef1643937339",
          title: "Selfies in Copenhagen",
          slug: "selfies-in-copenhagen",
          icon: "https://production-task-management-media-storage.s3.amazonaws.com/028__Desert_Island-Yellow.png",
          technology: {
            id: 2,
            name: "Django",
            language: "Python",
          },
        },
        {
          id: "9c778212-5cf0-4b5d-b2b5-49bea7eb1d53",
          title: "FizzBuzz JavaScript",
          slug: "fizzbuzz-javascript",
          icon: "https://production-task-management-media-storage.s3.amazonaws.com/tc_icon.png",
          technology: {
            id: 1,
            name: "",
            language: "JavaScript",
          },
        },
        {
          id: "58c45208-c9cc-474e-94d4-ced187b077e0",
          title: "Spaceship validation when entering the motherships",
          slug: "spaceship-validation-when-entering-the-motherships",
          icon: "https://production-task-management-media-storage.s3.amazonaws.com/Spaceship-Yellow.png",
          technology: {
            id: 1,
            name: "Spring Boot",
            language: "Java",
          },
        },
        {
          id: "bf876a38-3f94-4c65-a111-10b8e74e9623",
          title: "Pool Challenge Example 1",
          slug: "pool-challenge-example-1",
          icon: "https://production-task-management-media-storage.s3.amazonaws.com/Spaceship-Yellow.png",
          technology: {
            id: 1,
            name: "Laravel",
            language: "PHP",
          },
        },
        {
          id: "42d9c6e2-5948-49bc-8e70-52cadba58154",
          title: "Pool Challenge Example 2",
          slug: "pool-challenge-example-2",
          icon: "https://production-task-management-media-storage.s3.amazonaws.com/Spaceship-Yellow.png",
          technology: {
            id: 1,
            name: "React",
            language: "JavaScript",
          },
        },
        {
          id: "4dc8cf16-2783-445c-abc1-485d35280b16",
          title: "Pool Challenge Example 3",
          slug: "pool-challenge-example-3",
          icon: "https://production-task-management-media-storage.s3.amazonaws.com/Spaceship-Yellow.png",
          technology: {
            id: 1,
            name: "",
            language: "Python",
          },
        },
        {
          id: "56b3cdef-8754-444a-a5cd-a7972c2a6d96",
          title: "Pool Challenge Example 4",
          slug: "pool-challenge-example-4",
          icon: "https://production-task-management-media-storage.s3.amazonaws.com/Spaceship-Yellow.png",
          technology: {
            id: 1,
            name: "",
            language: "C++",
          },
        },
      ];
      result.loaded = true;
    }, Math.random() * 1500);
    return result;
  }

  getSolvedChallenge(userId) {
    let result = new SolvedChallengesResult();
    setTimeout(function() {
      result.apiData = [
        {
          image: "https://production-task-management-media-storage.s3.amazonaws.com/tc_icon.png",
          title: "Challenge Number 3",
          slug: "challenge-number-3",
          id: "58c45208-c9cc-474e-1111-ced187b077e1",
          groupId: "1646b818-2b41-4123-aee9-c33cff7b19a1",
          technology: {
            id: 2,
            name: "Spring Boot",
            language: "Java",
          },
        },
        {
          image: "https://production-task-management-media-storage.s3.amazonaws.com/028__Desert_Island-Yellow.png",
          title: "Challenge Number 2",
          slug: "challenge-number-2",
          id: "58c45208-c9cc-474e-94d4-ced187b077e2",
          groupId: "0095dd73-28ff-4d6f-81e1-b3304fe263cb",
          technology: {
            id: 3,
            name: "Django",
            language: "Python",
          },
        },
        {
          image: "https://production-task-management-media-storage.s3.amazonaws.com/028__Desert_Island-Yellow.png",
          title: "Challenge Number 4",
          slug: "challenge-number-4",
          id: "58c45208-c9cc-474e-94d4-ced187b077e3",
          groupId: "0095dd73-28ff-4d6f-81e1-b3304fe263cb",
          technology: {
            id: 3,
            name: "Spring Boot",
            language: "Java",
          },
        },
        {
          image: "https://production-task-management-media-storage.s3.amazonaws.com/tc_icon.png",
          title: "Challenge Number 1",
          slug: "challenge-number-1",
          id: "58c45208-c9cc-474e-94d4-ced187b077e4",
          groupId: "0095dd73-28ff-4d6f-81e1-b3304fe263cd",
          technology: {
            id: 1,
            name: "THREE.js",
            language: "JavaScript",
          },
        },
      ];
      result.loaded = true;
    }, Math.random() * 1500);
    return result;
  }

  downloadChallengeSolutionZip(acceptedChallengeUuid) {
    let result = new DownloadChallengeSolutionZipResult();
    setTimeout(function() {
      result.apiData = {
        "downloadLink": "https://codeload.github.com/polylith/test-download-repo-public/legacy.zip/refs/heads/master%23b9c3ac5b-35ad-4629-b14d-73bdc28cb6fb%236251963391541617",
      };
      result.loaded = true;
    }, Math.random() * 1500 + 1500);
    return result;
  }

  getDataOfMultipleChallengeTasks() {
    let result = new TaskList();
    setTimeout(function() {
      result.apiData = [
        {
          id: "1b20123e-0d49-4ea4-a213-59e869675172",
          challengeTitle: "The mighty oracle for 'CannotDoMuch#' programs",
          challengeSlug: "the-mighty-oracle-for-cannotdomuch-programs",
          challengeIcon: "https://production-task-management-media-storage.s3.amazonaws.com/tc_icon.png",
        },
        {
          id: "0b465303-ae29-44fc-9d17-e61732585a01",
          title: "Number of Islands",
          challengeSlug: "the-mighty-oracle-for-cannotdomuch-programs",
          challengeIcon:
            "https://production-task-management-media-storage.s3.amazonaws.com/028__Desert_Island-Yellow.png",
        },
        {
          id: "f0402749-0cee-45ae-9c90-7a6a0360d0f6",
          challengeTitle: "The mighty oracle for 'CannotDoMuch#' programs",
          challengeSlug: "the-mighty-oracle-for-cannotdomuch-programs",
          challengeIcon: "https://production-task-management-media-storage.s3.amazonaws.com/tc_icon.png",
        },
      ];
      result.loaded = true;
    }, Math.random() * 1500);
    return result;
  }

  getSolvedChallengesForPublicUserIds() {
    let result = new SolvedChallengesResultDict();
    setTimeout(function() {
      result.apiData = {
        "6296f40d95c3fdeb12216d525f44f362": [
          {
            challengeId: "1b20123e-0d49-4ea4-a213-59e869675172",
            acceptedChallengeUuid: "e6cdc688-90b6-448c-b548-cbaf1afed0d3",
            title: "The mighty oracle for 'CannotDoMuch#' programs",
            icon: "https://production-task-management-media-storage.s3.amazonaws.com/tc_icon.png",
            technology: { name: "Spring", programmingLanguage: "Java" },
          },
          {
            challengeId: "0b465303-ae29-44fc-9d17-e61732585a01",
            acceptedChallengeUuid: "534c72c9-acd2-44bf-860c-1a4f49d8193b",
            title: "Number of Islands",
            icon: "https://production-task-management-media-storage.s3.amazonaws.com/028__Desert_Island-Yellow.png",
            technology: { name: "Spring", programmingLanguage: "Java" },
          },
        ],
        "6296f40d95c3fdeb12216d525f44f36e": [
          {
            challengeId: "1b20123e-0d49-4ea4-a213-59e869675172",
            acceptedChallengeUuid: "7e1548b0-acf0-4856-a258-5b8917426fa5",
            title: "The mighty oracle for 'CannotDoMuch#' programs",
            icon: "https://production-task-management-media-storage.s3.amazonaws.com/tc_icon.png",
            technology: { name: "Django", programmingLanguage: "Python" },
          },
        ],
        "6296f40d95c3fdeb12216d525f44f36d": [
          {
            challengeId: "1b20123e-0d49-4ea4-a213-59e869675172",
            acceptedChallengeUuid: "4de1d092-327f-47ae-a091-e12ecf4d74aa",
            title: "The mighty oracle for 'CannotDoMuch#' programs",
            icon: "https://production-task-management-media-storage.s3.amazonaws.com/tc_icon.png",
            technology: { name: "Spring", programmingLanguage: "Java" },
          },
          {
            challengeId: "0b465303-ae29-44fc-9d17-e61732585a01",
            acceptedChallengeUuid: "9b27f628-afc3-43ba-b680-8955d1b04a70",
            title: "Number of Islands",
            icon: "https://production-task-management-media-storage.s3.amazonaws.com/028__Desert_Island-Yellow.png",
            technology: { name: "Spring", programmingLanguage: "Java" },
          },
        ],
      };
      result.loaded = true;
    }, Math.random() * 1500);
    return result;
  }

  getAcceptedChallengeDetails(acceptedChallengeUuid) {
    let result = new AcceptedChallengeDetails();
    setTimeout(() => {
      result.loaded = true;
      result.apiData = {
        challengeId: "54796871-1190-499d-8ec6-006ab5c2eb64",
        title: "Number of Islands",
        anonymizedUserName: "Brave Wozniak",
      };
    }, Math.random() * 1500);

    return result;
  }
}
